export default "__VITE_ASSET__7a238c23__"